<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{form.main.ip_code}}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="ip_vendname">
            <label class="weui-form-preview__label">{{customLabel.ip_vendname || "供应商"}}</label>
            <em class="weui-form-preview__value">{{form.main.ip_vendname}}</em>
          </div>
          <div class="weui-form-preview__item" slot="ip_contact">
            <label class="weui-form-preview__label">{{customLabel.ip_contact || "联系人"}}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon">{{form.main.ip_contact}} {{form.main.ip_tel}}
              <call-mobile :mobile="form.main.ip_tel"></call-mobile>
            </span>
          </div>
          <div class="weui-form-preview__item" slot="ip_successdate">
            <label class="weui-form-preview__label">{{customLabel.ip_successdate || "生效日期"}}</label>
            <span class="weui-form-preview__value" v-format="'yyyy年MM月dd日'">{{form.main.ip_successdate}}</span>
          </div>
          <div class="weui-form-preview__item" slot="ip_faildate">
            <label class="weui-form-preview__label">{{customLabel.ip_faildate || "截止日期"}}</label>
            <span class="weui-form-preview__value" v-format="'yyyy年MM月dd日'">{{form.main.ip_faildate}}</span>
          </div>
          <div class="weui-form-preview__item" slot="ip_currency">
            <label class="weui-form-preview__label">{{customLabel.ip_currency || "币种"}}</label>
            <span class="weui-form-preview__value">
              {{form.main.ip_currency}}
              <span v-if="form.main.ip_rate && form.main.ip_rate != 1"> / {{form.main.ip_rate}}</span>
            </span>
          </div>
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd form-detail-preview" v-for="item in form.items" :key="item.id">
          <div class="form-detail-preview_num">{{item.ipd_detno}}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-form-preview__item" slot="ipd_prodcode">
              <label class="weui-form-preview__label">{{customLabel.ipd_prodcode || "物料编号"}}</label>
              <span class="weui-form-preview__value">{{item.ipd_prodcode}}</span>
            </div>
            <div class="weui-form-preview__item" slot="pr_detail">
              <label class="weui-form-preview__label">{{customLabel.pr_detail || "物料名称"}}</label>
              <span class="weui-form-preview__value">{{item.productDTO.pr_detail}}</span>
            </div>
            <div class="weui-form-preview__item" v-if="item.productDTO.pr_orispeccode" slot="pr_orispeccode">
              <label class="weui-form-preview__label">{{customLabel.pr_orispeccode || "型号"}}</label>
              <span class="weui-form-preview__value">{{item.productDTO.pr_orispeccode}}</span>
            </div>
            <div class="weui-form-preview__item" v-if="item.productDTO.pr_spec" slot="pr_spec">
              <label class="weui-form-preview__label">{{customLabel.pr_spec || "规格"}}</label>
              <span class="weui-form-preview__value">{{item.productDTO.pr_spec}}</span>
            </div>
            <div class="weui-form-preview__item" v-if="item.productDTO.pr_brand" slot="pr_brand">
              <label class="weui-form-preview__label">{{customLabel.pr_brand || "厂家/品牌"}}</label>
              <span class="weui-form-preview__value">{{item.productDTO.pr_brand}}</span>
            </div>
            <div class="weui-form-preview__item" slot="pr_zxbzs">
              <label class="weui-form-preview__label">{{customLabel.pr_zxbzs || "最小包装数"}}</label>
              <span class="weui-form-preview__value">{{item.productDTO.pr_zxbzs}} {{item.productDTO.pr_unit}}</span>
            </div>
            <div class="weui-form-preview__item" slot="ipd_lapqty">
              <label class="weui-form-preview__label">{{customLabel.ipd_lapqty || "分段数量"}}</label>
              <span class="weui-form-preview__value">{{item.ipd_lapqty}} {{item.productDTO.pr_unit}}</span>
            </div>
            <div class="weui-form-preview__item" slot="ipd_price">
              <label class="weui-form-preview__label">{{customLabel.ipd_price || "单价"}}</label>
              <span class="weui-form-preview__value weui-form-preview__value-icon">
                {{item.ipd_price}}
                <router-link
                  class="iconfont icon-history"
                  :to="{path: '/purchase/order_report', query:{hq_keyword: item.ipd_prodcode} }"
                ></router-link>
              </span>
            </div>
            <div class="weui-form-preview__item" v-if="item.productDTO.pr_purcprice" slot="pr_purcprice">
              <label class="weui-form-preview__label">{{customLabel.pr_purcprice || "最近购价(元)"}}</label>
              <span class="weui-form-preview__value">{{
                numberFormat(item.productDTO.pr_purcprice,'#,##0.####')
              }}</span>
            </div>
            <div class="weui-form-preview__item" v-if="item.ipd_remark" slot="ipd_remark">
              <label class="weui-form-preview__label">{{customLabel.ipd_remark || "备注"}}</label>
              <span class="weui-form-preview__value">{{item.ipd_remark}}</span>
            </div>
          </custom-layout>
        </div>
      </div>

      <div class="form-preview weui-form-preview" v-if="form.main.ip_remark">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">备注</label>
            <span class="weui-form-preview__value">{{form.main.ip_remark}}</span>
          </div>
        </div>
      </div>
      <file-list v-model="form.main.ip_attach" />
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import FileList from "@/components/FileList.vue";
import form from "@/mixins/form.js";
import CallMobile from "@/components/button/CallMobile.vue";

export default {
  mixins: [form],
  components: {
    CustomLayout,
    FileList,
    CallMobile
  },
  data() {
    return {
      baseUrl: "/api/purchase/inquiryprice",
      caller: "InquiryPrice",
      xtype: "purchase-b2b-inquiryprice-formpanel",
    };
  }
};
</script>